import React, { FC, useCallback, useMemo, useState, useContext } from 'react'
import { Map, List } from 'immutable'

import {
  getSelectedBlocksList,
} from 'draftjs-utils'

import {
  EditorState,
  ContentBlock,
  Modifier,
} from 'draft-js'

import EditorContext from './EditorContext'

import {
  IForm_Color,
} from '@kaidam/fc-shared/src/types/schema/form'

import {
  ITextEditor_EditorUpdate,
} from '@kaidam/fc-shared/src/types/texteditor'

import Window from '../dialog/Window'
import ColorPicker from '../colorpicker/ColorPicker'

import {
  TEXT_EDITOR_DEFAULT_COLOR,
} from '@kaidam/fc-shared/src/constants'

import {
  IconComponentType,
} from '../../types/app'

import ToolbarButton from './ToolbarButton'

interface ToolbarColorButtonProps {
  name: string,
  className?: string,
  icon: IconComponentType,
  editorState: EditorState,
  setEditorState: ITextEditor_EditorUpdate,
}

const ToolbarColorButton: FC<React.PropsWithChildren<ToolbarColorButtonProps>> = ({
  name,
  className,
  icon,
  editorState,
  setEditorState,
}) => {

  const [ editingColor, setEditingColor ] = useState<IForm_Color | null>(null)

  const editorContext = useContext(EditorContext)

  const onCancel = useCallback(() => {
    setEditingColor(null)
    setTimeout(() => {
      editorContext.focus()
    }, 0)
  }, [])

  const onChange = useCallback(() => {
    const newContentState = Modifier.mergeBlockData(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      Map().set(name, editingColor),
    )
    const newEditorState = EditorState.push(
      editorState,
      newContentState,
      'change-block-data',
    )
    setEditorState(newEditorState)
    onCancel()
  }, [
    editingColor,
    editorState,
  ])

  const currentValue = useMemo<IForm_Color>(() => {
    if(!editorState || !name) return false
    const blocks = getSelectedBlocksList(editorState) as List<ContentBlock>
    const selectedBlocks = blocks.size
    if(selectedBlocks != 1) return TEXT_EDITOR_DEFAULT_COLOR
    const firstBlock = blocks.toArray()[0]
    if(!firstBlock) return TEXT_EDITOR_DEFAULT_COLOR
    const colorValue = firstBlock.getData().get(name)
    return colorValue || TEXT_EDITOR_DEFAULT_COLOR
  }, [
    editorState,
    name,
  ])

  return (
    <>
      <ToolbarButton
        title="color"
        className={ className }
        icon={ icon }
        active={ false }
        onClick={ () => setEditingColor(currentValue) }
      />
      {
        editingColor && (
          <Window
            open
            size="sm"
            cancelTitle="Cancel"
            submitTitle="Save Colour"
            onCancel={ onCancel }
            onSubmit={ onChange }
          >
            <ColorPicker
              intent='primary'
              value={ editingColor }
              onUpdate={ setEditingColor }
            />
          </Window>
        )
      }
    </>
  )
}

export default ToolbarColorButton